import React, { Fragment } from 'react'

import telephone from '@scoir/components-core/dist/components/telephone'
import PropTypes from 'prop-types'

import './Display.scss'

export default class Display extends React.Component {
  static propTypes = {
    showEmail: PropTypes.bool,
    user: PropTypes.object.isRequired,
  }
  static defaultProps = {
    showEmail: false,
  }
  render() {
    const { user, showEmail } = this.props
    const name = [user.FirstName, user.MiddleName, user.LastName].join(' ')
    const mdashIfEmpty = (val) => val || <Fragment> &mdash; </Fragment>
    return (
      <div className="display-my-profile-comp">
        <div className="info-row">
          <strong>Name</strong>
          <span className="name-display">{name}</span>
        </div>
        <div className="info-row">
          <strong>Title</strong>
          <span className="title-display">{mdashIfEmpty(user.Title)}</span>
        </div>
        {showEmail && (
          <div className="info-row">
            <strong>Email</strong>
            <span className="email-display">{mdashIfEmpty(user.Email)}</span>
          </div>
        )}
        <div className="info-row">
          <strong>Work</strong>
          <span className="work-display">{mdashIfEmpty(telephone.format(user.Phone))}</span>
          <strong>Ext.</strong>
          <span className="ext-display">{mdashIfEmpty(user.PhoneExtension)}</span>
        </div>
        <div className="info-row">
          <strong>Cell</strong>
          <span className="cell-display">{mdashIfEmpty(telephone.format(user.CellPhone))}</span>
        </div>
      </div>
    )
  }
}
